/*
*
* Modal behaviour && popup members
*
* */

const overlay = $('modal'),
	popupClose = 'popup-members-close',
	$popupClose = $('popup-members-close'),
	$popupHeadline = $('members-headline'),
	$popupDescription = $('members-description'),
	$popupSend = $('popup-send'),
	$popupInvite = $('popup-invite'),
	$membersForm = $('.popup-members'),
	memberAllWrapper = 'member-all',
	$memberAllWrapper = $('member-all'),
	$memberList = $('member-list');
let socket = null;

let users = [];
let inviteList = [];

export let PopupUI = {
	init(socketInstance){
		socket = socketInstance;
		// this.actions.popupPopulate();
		this.addListeners();
	},
	addListeners(event){
		overlay.on('click', popupClose, this.actions.modalOff);
		overlay.on('change', `${memberAllWrapper} input`, this._listeners.memberSelectAll);
		$membersForm.on('submit', this._listeners.memberInvite);
		$membersForm.on('change', `member-invite input`, this._listeners.memberSelect);
		$popupSend.on('click', event, this._listeners.memberInvite);
		socket.on('requested invitation', emails => {
			users = emails;
			this.actions.usersMapInitial(users);
			if (users.length > 1) {
				$memberAllWrapper.html(PopupUI.actions.memberAdd({email: null, initials: null, name: 'All'}));
			}
		});
	},
	_listeners: {
		memberSelectAll(){
			if ($(this).prop('checked')){
				$memberList.find('input').each( (index, item, arr) => {
					$(item).prop('checked', true);
				})
			} else {
				$memberList.find('input').each( (index, item, arr) => {
					$(item).prop('checked', false);
				})
			}
		},
		memberSelect(event){
			const target = event.target
			const $memberAllInput = $(`${memberAllWrapper} input`);
			// push/splice user to/from inviteList
			$(this).prop('checked') ?
				inviteList.push(target.value) :
				inviteList.splice(inviteList.indexOf(target.value), 1);
			
			// mark/unmark 'check all users button'
			inviteList.length === users.length && inviteList.length > 1 ?
				$memberAllInput.prop('checked', true) :
				$memberAllInput.prop('checked', false);
			
			//send button availability
			inviteList.length ? $popupSend.removeClass('disabled') : $popupSend.addClass('disabled');
		},
		memberInvite(event){
			event.preventDefault();
			socket.emit('invite users', inviteList);
			$memberList.append(`<loading><i class="fas fa-atom loading"></i></loading>`)
			setTimeout(()=>{
				PopupUI.actions.popupSuccess()
				setTimeout(()=>{
					PopupUI.actions.modalOff();
				}, 600);
			}, 500);
		},
		usersAvailableGet(emails){
		
		}
	},
	actions: {
		usersMapInitial(connectedUsers){
			$memberList.empty();
			connectedUsers.forEach(user => {
				$memberList.append(PopupUI.actions.memberAdd(user))
			})
		},
		memberAdd(user){
			return `
				<member-invite class="checkbox">
					<label>
						<input type="checkbox" name="email" value="${user.email}">
						<span><i class="fas fa-check"></i></span>
						<span>${user.name}</span>
					</label>
				</member-invite>
			`;
		},
		memberRemove(user){
			console.log(`Remove an ${user.name} with an email ${user.email}`);
		},
		popupSuccess(){
			const message = inviteList.length > 1 ? 'Invitations were sent' : 'Invitation was sent';
			$popupHeadline.html(message);
			$popupDescription.html('');
			PopupUI.actions.popupClear();
		},
		popupPopulate(){
			$popupHeadline.html('Invite team members');
			$popupDescription.html('You can pick individual users or invite entire groups:');
			$popupClose.html('<i class="fas fa-times"></i>');
			$popupSend.html('<i class="fas fa-paper-plane"></i>');
			$popupInvite.html(`If you want to invite another person please ask your administrator or <a href="#">upgrade the plan.</a>`);
		},
		modalOn(){
			// ask users available to invite
			socket.emit('request invitation');
			// populate popup content
			PopupUI.actions.popupPopulate();
			// add loading screen
			$memberList.append(`<loading><i class="fas fa-atom loading"></i></loading>`)
			// show overlay with popup
			overlay.addClass('active');
		},
		modalOff(){
			overlay.removeClass('active');
			PopupUI.actions.popupClear();
		},
		popupClear(){
			users = [];
			inviteList = [];
			$memberAllWrapper.empty();
			$memberList.empty();
			$popupSend.addClass('disabled');
		}
	}
}
